import './About.css'
import { FC, useContext } from "react"
import { Flex } from 'antd'
import { ResponsiveContext } from '../../context/responsive-context'
import { about } from '../../contents/about'

export const About: FC = () => {
  const { useVertical } = useContext(ResponsiveContext)
  return (
    <>
    {!useVertical &&
    <Flex className="About-container">
    <Flex className="About-main-container">
    <Flex className="About-main-text-container" vertical justify={'space-evenly'} style={{ height: '100%', width: '50%'}}>
    {about.main.paragraphs.map(p => {
      return (
        <div className="About-main-text">
          {p}
        </div>
      )
    })}
    </Flex>
    <Flex style={{height: '100%', width: '50%' }}>
      <div className="About-main-pic" style={{
        width: '100%',
        margin: 50,
        backgroundSize: 'cover',
      }}>
      </div>
    </Flex>
    </Flex>
    </Flex>
    }
    {useVertical &&
      <Flex className="About-container">
    <Flex className="About-main-container-vertical" vertical>
    <Flex className="About-main-text-container-vertical" vertical justify={'space-evenly'} style={{ height: '100%', width: '100%'}}>
    {about.main.paragraphs.map(p => {
      return (
        <div className="About-main-text-vertical">
          {p}
        </div>
      )
    })}
    </Flex>
    <Flex style={{height: '100%', width: '100%' }}>
      <div className="About-main-pic" style={{
        width: '100%',
        margin: 50,
        backgroundSize: 'cover',
      }}>
      </div>
    </Flex>
    </Flex>
      </Flex>
    }
    </>
  )
}
